<template>
  <div>
    <main-content></main-content>
    <cookie-consent></cookie-consent>
  </div>

</template>

<script>
import MainContent from './Main/MainContent.vue'
import CookieConsent from './Main/CookieConsent.vue';

export default {
  components: { MainContent, CookieConsent },

}
</script>

<style scoped>

</style>